import Auth from "../auth/Auth.js";
import HipHop from "./hiphop.js";

const auth = new Auth(HipHop, null);

export default auth;